import { useHistory } from 'react-router-dom'

export default function usePathHistory() {
	const pathHistory = useHistory()

	return pathHistory
}